import { Bell, BellOff, Loader2, Smartphone } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import { cn } from '@/lib/utils';

export function PushNotificationToggle() {
  const { isSupported, isSubscribed, permission, loading, subscribe, unsubscribe } = usePushNotifications();

  const handleToggle = async () => {
    if (isSubscribed) {
      await unsubscribe();
    } else {
      await subscribe();
    }
  };

  if (!isSupported) {
    return (
      <div className="flex items-center gap-3 p-4 rounded-xl bg-muted/50 border border-border/50">
        <Smartphone className="h-5 w-5 text-muted-foreground" />
        <div className="flex-1">
          <p className="text-sm font-medium">Notifications push</p>
          <p className="text-xs text-muted-foreground">
            Non disponible sur ce navigateur. Installez l'application pour activer les notifications.
          </p>
        </div>
      </div>
    );
  }

  const isDenied = permission === 'denied';

  return (
    <div className={cn(
      "flex items-center gap-3 p-4 rounded-xl border transition-all",
      isSubscribed 
        ? "bg-primary/5 border-primary/20" 
        : "bg-muted/50 border-border/50"
    )}>
      <div className={cn(
        "p-2 rounded-lg",
        isSubscribed ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground"
      )}>
        {isSubscribed ? <Bell className="h-5 w-5" /> : <BellOff className="h-5 w-5" />}
      </div>
      
      <div className="flex-1">
        <Label htmlFor="push-notifications" className="text-sm font-medium cursor-pointer">
          Notifications push
        </Label>
        <p className="text-xs text-muted-foreground">
          {isDenied 
            ? "Notifications bloquées. Modifiez les paramètres du navigateur."
            : isSubscribed 
              ? "Vous recevrez des alertes pour les documents expirants"
              : "Activez pour recevoir des alertes sur votre appareil"
          }
        </p>
      </div>

      {loading ? (
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      ) : (
        <Switch
          id="push-notifications"
          checked={isSubscribed}
          onCheckedChange={handleToggle}
          disabled={isDenied}
        />
      )}
    </div>
  );
}
